/* eslint-disable require-jsdoc */

import $ from 'jquery';
import { debug } from '../../../../config';
import {currDate} from '../../utils/date';
import {getOption, getLocOptions} from '../../utils/option';
import {closePopUpListener, createPopUp} from './clickEvents';
// import * as config from 'src/config.json';
// import {A4map} from '../A4map';
// import {InfoWindow} from '../infoWindow/infowindow';
// import {getLocation} from '../map/gMap';

export class EventPopUp {
  constructor(options = {}) {
    this.mapPopUp = getOption(options, 'mapPopUp', true);
    this.popUpId = getOption(options, 'popUpId', undefined);
    this.mapId = getOption(options, 'mapId', undefined);
    this.mapObj = getOption(options, 'mapObj', undefined);
    // this.sliderId = getOption(options, 'sliderId', undefined);
    // this.aMap = map;
    // this.map = A4map.
    // this.debug = getOption(options, 'debug', true);
    this.gMapApiKey = getOption(options, 'gMapApiKey', undefined);
    this.MapCenter = getLocOptions(options, 'loc', 'ooops');
    this.date = getOption(options, 'date', currDate());
    this.pageType = getOption(options, 'pageType', '');
    this.eventId = getOption(options, 'popupEventId', 991793);
    this.venueId = getOption(options, 'venueId', 0);
    this.venueName = getOption(options, 'venueName', '');
    this.lat = getOption(options, 'lat', 0.0);
    this.lng = getOption(options, 'lng', 0.0);
    this.dist = getOption(options, 'dist', 0);
    this.currentScrollY = 0;
    this.defaultImg = getOption(options, 'defaultImg', '');
    this.markerObj = getOption(options, 'markerObj', undefined);
    this.mapData = getOption(options, 'mapData', undefined);
    this.widgetID = getOption(options, 'widgetID', undefined);
    this.el = document.querySelector('.hearby-map-popup');
  }
  async init() {
    // set loader gif
    const self = this;
    debug && console.log('map pop up enabled 1', self.mapPopUp);
    // document.addEventListener('DOMContentLoaded', (event) => {
    //  this.mapData ? this.mapData : A4map.map
    debug && console.log('map pop up enabled 2', self.mapPopUp);
    self.mapPopUp ? self.loadMapClickEvent() : self.loadClickEvent();
    // });
  }
  loadClickEvent() {
    debug && console.log('load');

    closePopUpListener(this);
  }
  loadMapClickEvent() {
    debug && console.log('click event');

    // setPopUp(this.MapCenter, this);
    closePopUpListener(this);
  }
  popUpEvent(self, event) {
    event.stopPropagation();
    event.preventDefault();
    this.eventId = $(self).attr('event-id');
    this.dist = $(self).attr('event-dist');
    debug && console.log('createPopUp ', this.eventId, this.dist);
    createPopUp(this);
    return false;
  }
}
